/**
 * @file common-state
 */
import constantState from './utils/constants';
import {webPages} from './utils/pages';
import topicFilterState from './topicFilter';

export default {
    ...constantState,
    webPages,
    ...topicFilterState
};
